export const CONFIG_PROPERTY_ROUTE_PREFIX = "/settings/config-properties";

export const CONFIG_PROPERTY_ROUTE_PATHS = {
  list: { path: "*", to: CONFIG_PROPERTY_ROUTE_PREFIX }
};
